import { getModel } from "core-web/state";
import { post } from "core-web/libs/GrebbCommerceAPI/util";

export default async (basketId: string, promotionIds: string[]) => {
    const applicationId: number = getModel("application").applicationId;
    const email: string = getModel("user").email;

    return await post(`/frontend/basket/${basketId}/promotion`, {
        application_id: applicationId,
        email,
        promotion_ids: promotionIds,
    });
};
